import { Mic, Plus, Sparkles, UserSquare2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button } from "@/shared/ui/button";
import { PageHeader } from "@/shared/ui/PageHeader";
import { RecentWorksRow } from "@/entities/work/ui/RecentWorksRow";
import { DEPT_TITLE_KEY } from "@/entities/work/model/deptTitles";
import { DH_LINE_ROUTE } from "@/entities/dh-profile/model/dhLines";
import { DhHubSections } from "./components/DhHubSections";

/**
 * 数字分身工作室 —— **纯卡墙**(2026-07-24 IA 二次收口 F1-b)。
 *
 * 原本这里还挂着「进行中 + 历史(状态 chips + 场景 chips + 搜索 + 真分页)」——
 * 393 行里 11 处是历史。检索整体搬去 `/works`(唯一落点),这里只留一条
 * 「最近作品 · 查看全部 →」。收藏 / 重命名 / 删除在 `/works` 全都在,一条没丢。
 *
 * 分身线重试(1015):api 已有 `POST /digital-human/tasks/{id}/retry`(D2 补齐原始参数后可原样复原),
 * `/works` 的分身失败卡已出「重试」按钮(新建任务、重新扣积分,确认框写明)。
 */
export default function DigitalHumanHomePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="w-full space-y-6">
      <PageHeader
        icon={UserSquare2}
        title={t(DEPT_TITLE_KEY.dh)}
        subtitle="口播出镜 + 产品插播画面标记,朗读 10 秒以上(录到 19 秒自动停)即可克隆专属音色 —— 口播公式一键套真产品。"
        actions={
          <>
            <Button variant="outline" onClick={() => navigate("/ai-digital-human/showcase")}>
              <Sparkles className="mr-2 h-4 w-4" />
              样片墙
            </Button>
            {/* packs W2:「我的资产」收编进人物库(真人原料 Tab),入口改指人物库。 */}
            <Button variant="outline" onClick={() => navigate("/characters")}>
              <Mic className="mr-2 h-4 w-4" />
              人物库
            </Button>
            {/* IA 收尾:直指真人口播线,不再经 `/create` 跳板(少一跳、URL 不闪)。 */}
            <Button onClick={() => navigate(DH_LINE_ROUTE.talking)}>
              <Plus className="mr-2 h-4 w-4" />
              创作口播视频
            </Button>
          </>
        }
      />

      {/* 快捷卡墙 + 公共形象横排 */}
      <DhHubSections />

      <RecentWorksRow
        lines={["dh"]}
        onOpen={(w) => navigate(w.detailRoute)}
        onViewAll={(href) => navigate(href)}
      />
    </div>
  );
}
